/*
 * ===============================================================================================================
 *                                Copyright 2020, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { makeStyles } from 'tss-react/mui';
import { Tokens } from '@jda/lui-common-component-library-mui5';

export const useStyles = makeStyles()(theme => ({
  root: {
    display: "grid",
    justifyContent: "center",
    '& .MuiGrid-root.MuiGrid-wrap-xs-nowrap': {
      flexDirection: 'row'
    }
  },
  listWrapper: {
  },
  inputMargin: {
    marginBottom: Tokens.spacing['$sp-4']
  },
  innerContent: {
    marginTop: '40%',
    textAlign: 'center'
  },
  titleAlignment: {
    fontSize: Tokens.spacing['$sp-6'],
    marginBottom: Tokens.spacing['$sp-4'],
  },
  loader: {
    textAlign: 'center',
    alignItems: 'center',
    padding: Tokens.spacing['$sp-3']
  },
  progressBarWrap: {
    zIndex: 1,
    top: "50%",
    left: "50%",
    position: "absolute",
    padding: Tokens.spacing['$sp-2'],
    boxShadow: '1px 2px 9px #000000',
    backgroundColor: theme.palette.common.white,
  },
  circlularLoader: {
    alignSelf: "center",
    alignContent: "center",
    justifyContent: "center",
    marginLeft: Tokens.spacing['$sp-14'],
  },
  searchIcon: {
    padding: 0,
    color: theme.palette.text.secondary,
    cursor: 'initial'
  },
  roleItem: {
    '&:hover': {
      backgroundColor: "transparent",
    }
  },
  warningInfoWrap: {
    margin: `${Tokens.spacing['$sp-4']} 0`,
  },
  divider: {
    marginTop: Tokens.spacing['$sp-8-5'],
    marginBottom: Tokens.spacing['$sp-6']
  },
  tabHeader: {
    fontSize: Tokens.spacing['$sp-4-5'],
  },
  idpRolesSubtitle: {
    color: theme.palette.text.secondary
  },
  contentContainer: {
    marginTop: Tokens.spacing['$sp-6']
  }
}));
